// @ts-strict-ignore
import { MiniTerminalBlocksInitialProjectData } from './mini-terminal-blocks-project-creation.service';

export interface MiniTerminalArticleInfo {
  size: number;
  actuationType: MiniTerminalActuationType;
  mountingType: MiniTerminalMountingType;
  articleNumbers: string[];
}

export enum MiniTerminalActuationType {
  PUSH_BUTTON = 'Push-button',
  PUSH_IN = 'Push-in'
}

export enum MiniTerminalMountingType {
  TS15 = 'TS15',
  TS35 = 'TS35',
  FLANGE = 'Flange',
  SNAP_FOOT = 'Snap-foot'
}

export class MiniTerminalArticleInfoDef {
  public static readonly ARTICLE_INFOS: MiniTerminalArticleInfo[] = [
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.TS15,
      articleNumbers: ['210-111', '2250-1201'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.TS35,
      // TODO add article number for rail when building algorithm for TS35 mounting type will be implemented
      articleNumbers: ['2050-391', '2250-321', '209-120', '2250-311'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.FLANGE,
      articleNumbers: ['2050-381', '2250-321', '2250-301'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.SNAP_FOOT,
      articleNumbers: ['2250-321', '2250-311'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.TS15,
      articleNumbers: ['210-111', '2050-1201'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.TS35,
      // TODO add article number for rail when building algorithm for TS35 mounting type will be implemented
      articleNumbers: ['2050-391', '2050-321', '209-120', '2050-311'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.FLANGE,
      articleNumbers: ['2050-381', '2050-321', '2050-301'],
    },
    {
      size: 1,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.SNAP_FOOT,
      articleNumbers: ['2050-321', '2050-311'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.TS15,
      articleNumbers: ['210-111', '2252-1201'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.TS35,
      // TODO add article number for rail when building algorithm for TS35 mounting type will be implemented
      articleNumbers: ['2052-391', '2252-321', '209-120', '2252-311'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.FLANGE,
      articleNumbers: ['2052-381', '2252-321', '2252-301'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_BUTTON,
      mountingType: MiniTerminalMountingType.SNAP_FOOT,
      articleNumbers: ['2252-321', '2252-311'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.TS15,
      articleNumbers: ['210-111', '2052-1201'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.TS35,
      // TODO add article number for rail when building algorithm for TS35 mounting type will be implemented
      articleNumbers: ['2052-391', '2052-321', '209-120', '2052-311'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.FLANGE,
      articleNumbers: ['2052-381', '2052-321', '2052-301'],
    },
    {
      size: 2.5,
      actuationType: MiniTerminalActuationType.PUSH_IN,
      mountingType: MiniTerminalMountingType.SNAP_FOOT,
      articleNumbers: ['2052-321', '2052-311'],
    }
  ];

  public static getArticleNumbers(initialProjectData: MiniTerminalBlocksInitialProjectData): string[] {
    if (!initialProjectData) {
      return null;
    }
    const articleInfo: MiniTerminalArticleInfo = this.ARTICLE_INFOS.find((info: MiniTerminalArticleInfo) => {
      return info.size === initialProjectData.size
        && info.actuationType === initialProjectData.actuationType
        && info.mountingType === initialProjectData.mountingType;
    });
    if (articleInfo) {
      return articleInfo.articleNumbers;
    }
    return null;
  }
}
